<template>
  <div class="wrapper" v-loading="loading">
    <div class="loginwrap">
      <div class="banner">
        <img src="../../image/logo/admin_banner.png" alt="" />
      </div>
      <div class="content">
        <div class="title">控制台登录</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          @keyup.enter.native="submitForm('ruleForm')"
        >
          <el-form-item prop="username">
            <el-input
              v-model="ruleForm.username"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="ruleForm.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-button type="primary" size="" @click="submitForm('ruleForm')"
            >立即登录</el-button
          >
        </el-form>
      </div>
    </div>
    <div class="login-box">
      <div class="puzzle-box">
        <PuzzleVerification
          v-model="isVerificationShow"
          :puzzleImgList="puzzleImgList"
          blockType="puzzle"
          :onSuccess="handleSuccess"
          width="300"
          height="200"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { adminLogin } from "@/common/api.js";
import PuzzleVerification from "vue-puzzle-verification";
export default {
  components: { PuzzleVerification },
  props: {},
  data() {
    return {
      ruleForm: {
        username: "",
        password: "",
        code: "",
      },
      loading: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [
          { required: true, validator: this.validateCode, trigger: "blur" },
        ],
      },
      userFlag: "", //随机标识
      verificationImg: "",
      isVerificationShow: false,
      puzzleImgList: [
        require("../../image/puzzleImg/img1.jpg"),
        require("../../image/puzzleImg/img2.jpg"),
        require("../../image/puzzleImg/img3.jpg"),
        require("../../image/puzzleImg/img4.jpg"),
        require("../../image/puzzleImg/img5.jpg"),
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isVerificationShow = true;
        } else {
          return false;
        }
      });
    },
    handleSuccess() {
      this.isVerificationShow = false;
      var params = {
        userName: this.ruleForm.username,
        userPwd: this.ruleForm.password,
      };
      this.loading = true;
      adminLogin(params).then((res) => {
        console.log("adminLogin :>> ", res);
        this.loading = false;
        if (res.code == 200) {
          this.$router.push({
            path: "/system/home/index",
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.login-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  margin-top: -200px;
}
.wrapper {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
  .loginwrap {
    width: 100%;
    height: 100%;
    .banner {
      width: 60%;
      height: 100%;
      img {
        width: 100%;
      }
    }
    .content {
      position: absolute;
      right: 10%;
      top: 40%;
      width: 20%;
      .title {
        font-size: 24px;
        color: rgba(0, 0, 0, 1);
      }
      .el-form {
        margin-top: 20px;
        .input3 {
          width: 70%;
        }
        .image {
          width: 30%;
          vertical-align: bottom;
          height: 40px;
        }
        .el-button {
          width: 100%;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/login.vue